import { createContext, useContext } from 'react';

/**
 * Starts the application over from a blocking alert (`blockContinueRestart`): FormShell clears the
 * current step's answers and returns to the Welcome step — legacy RIF's "not a Canadian resident"
 * dialog (QA RIF TC-06-03). Absent outside FormShell (builder previews), where closing just closes.
 */
export const RestartFromBlockContext = createContext<(() => void) | null>(null);

export const useRestartFromBlock = () => useContext(RestartFromBlockContext);
